export default "__VITE_ASSET__DR4QBp2q__"